import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";

import { Link } from "react-router-dom";
import classModal from "models/class.modal";

const TutorsLeadBoard = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = (modalName) => {
    setModal(!modal);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const getListData = async () => {
    setIsLoading(true);
    await classModal
      .listClass(parameters)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setDataList(result);
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  useEffect(() => {
    getListData();
  }, [location]);

  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this Message", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          classModal.deleteclass(delId).then((res) => {
            helper.sweetalert.toast(res.data?.message);
            getListData();
          });
        }
      });
  };

  console.log(dataList, "dataListaskjd");

  return (
    <>
      <Container className="pt-7">
        {!isLoading && (
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between ">
                  <h3 className="mb-0">All Tuter LeaderBoard</h3>

                  <div className="d-flex flex-row">
                    {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                    <Input
                      className="mr-4"
                      type="text"
                      placeholder="Search"
                      size="sm"
                    />
                    <Button
                      size="sm"
                      to="/admin/addLeadeBoard"
                      tag={Link}
                      color="primary"
                      style={{width:"80%",backgroundColor:"#080278",color:"white",border:"none",alignItems:"center",display:"flex",justifyContent:"center"}}
                    >
                      +Add Leader Board
                    </Button>
                  </div>
                </CardHeader>

                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">SN NO.</th>
                      {/* <th scope="col">CLASS ID</th> */}
                      <th scope="col">Title</th>
                      <th scope="col">Lead 1</th>
                      <th scope="col">Lead 2</th>
                      <th scope="col">Lead 3</th>
                      <th scope="col">Created date </th>
                      {/* <th scope="col">Action</th> */}
                    </tr>
                  </thead>
                  {/* {!isLoading && (
                    <tbody>
                      {dataList?.data?.length > 0 ? (
                        dataList?.data?.map((item, index) => {
                          return (
                            <tr key={item._id} style={{ cursor: "pointer" }}>
                              <td>{((currentPage-1) * perPage) + index + 1}</td>

                              <td>{item?.name || "-"} </td>
                              <td>{item?.parent || "-"}</td>
                              <td>{item?.tutor || "-"}</td>
                              <td>{item?.price_tutor || "-"}</td>
                              <td>{item?.price_parent || "-"}</td>
                              <td>{item?.status || "-"}</td>
                              <td>{item?.mode || "-"}</td>
                              <td>{item?.type || "-"}</td>

                              <td
                                className="p-0"
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  // justifyContent: "center",
                                  // alignItems: "center",
                                }}
                              >
                                <UncontrolledTooltip
                                  placement="top"
                                  target="eyeTooltip"
                                >
                                  Edit
                                </UncontrolledTooltip>
                                <Link
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "blue",
                                    // backgroundColor: "#f5f5f5",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "30%", // Optional: Make it a circle
                                  }}
                                  id="eyeTooltip"
                                  to={`/admin/classes/editclasss/${item?.id}`}
                                >
                                  <i className="fa-solid fa-pen-to-square"></i>
                                </Link>

                                

                                <UncontrolledTooltip
                                  placement="top"
                                  target="studentlist"
                                >
                                  Student List
                                </UncontrolledTooltip>
                                <Link
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "blue",
                                    // backgroundColor: "#f5f5f5",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "30%", // Optional: Make it a circle
                                  }}
                                  id="studentlist"
                                  to={`/admin/studentlist`}
                                >
                                  <i class="fa-solid fa-list"></i>
                                </Link>

                                <UncontrolledTooltip
                                  placement="top"
                                  target="Attendenc"
                                >
                                  Attendence
                                </UncontrolledTooltip>
                                <Link
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "blue",
                                    // backgroundColor: "#f5f5f5",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "30%", // Optional: Make it a circle
                                  }}
                                  id="Attendenc"
                                  to={`/admin/attendance`}
                                >
                                  <i class="fa-solid fa-clipboard-user"></i>
                                </Link>
                                <UncontrolledTooltip
                                  placement="top"
                                  target="userTooltip"
                                >
                                  Delete
                                </UncontrolledTooltip>
                                <p
                                  style={{
                                    margin: "0 8px",
                                    fontSize: "15px",
                                    color: "red",
                                    marginTop: "10px",
                                    // backgroundColor: "#f5f5f5",
                                    display: "inline-block",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "20%", // Optional: Make it a circle
                                  }}
                                  id="userTooltip"
                                  onClick={() => handleDel(item.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </p>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr style={{ textAlign: "center" }}>
                          <td colSpan="6" style={{ verticalAlign: "middle" }}>
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )} */}
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>name</td>
                      <td>name</td>
                      <td>100</td>
                      <td>100/50</td>
                      <td>12/04/2024</td>
                    </tr>
                  </tbody>
                </Table>
                <CardFooter className="py-4">
                  <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/classes?"
                  />
                </CardFooter>
              </Card>
            </div>
          </Row>
        )}

        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
      </Container>
    </>
  );
};

export default TutorsLeadBoard;
